import { create } from 'zustand'

let timeoutId = null

export const useUiStore = create((set) => ({
  notice: null,
  showNotice: (message) => {
    if (timeoutId) clearTimeout(timeoutId)

    set({ notice: message })
    timeoutId = setTimeout(() => set({ notice: null }), 2400)
  },
  clearNotice: () => {
    if (timeoutId) clearTimeout(timeoutId)
    set({ notice: null })
  },
}))
